/**
 * Resets all employer-related data in the global store by setting the fields (name, address, street number, postal code, city, phone) to null.
 */
export const resetEmployerData = () => {
    const employerName = useState<null | string>('employerName', () => null)
    const employerAddress = useState<null | string>('employerAddress', () => null)
    const employerStreetNumber = useState<null | string>('employerStreetNumber', () => null)
    const employerPostalCode = useState<null | string>('employerPostalCode', () => null)
    const employerCity = useState<null | string>('employerCity', () => null)
    const employerPhone = useState<null | string>('employerPhone', () => null)

    employerName.value = null;
    employerAddress.value = null;
    employerStreetNumber.value = null;
    employerPostalCode.value = null;
    employerCity.value = null;
    employerPhone.value = null;
};